module.exports = __webpack_public_path__ + "img/2.1423e1c3.png";